var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleSmallFillWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    fill: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0756 16.8254L11.0756 11.6823C11.0756 11.4371 11.173 11.2019 11.3463 11.0286C11.5197 10.8552 11.7548 10.7578 12 10.7578C12.2452 10.7578 12.4803 10.8552 12.6537 11.0286C12.8271 11.2019 12.9245 11.4371 12.9245 11.6823L12.9245 16.8254C12.9245 17.0706 12.8271 17.3057 12.6537 17.4791C12.4803 17.6525 12.2452 17.7499 12 17.7499C11.7548 17.7499 11.5197 17.6525 11.3463 17.4791C11.173 17.3057 11.0756 17.0706 11.0756 16.8254ZM12 9.23004C11.7803 9.23004 11.5654 9.16487 11.3827 9.04278C11.2 8.92069 11.0576 8.74716 10.9735 8.54413C10.8894 8.3411 10.8674 8.11769 10.9103 7.90216C10.9531 7.68662 11.059 7.48864 11.2144 7.33325C11.3697 7.17786 11.5677 7.07204 11.7833 7.02916C11.9988 6.98629 12.2222 7.00829 12.4252 7.09239C12.6283 7.17649 12.8018 7.3189 12.9239 7.50162C13.046 7.68435 13.1111 7.89917 13.1111 8.11892C13.1111 8.41361 12.9941 8.69622 12.7857 8.9046C12.5773 9.11297 12.2947 9.23004 12 9.23004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleSmallFillWhite);
export default __webpack_public_path__ + "static/media/info-circle-small-fill-white.c747a3b75a40c42ac6a8f7f8fca8a6b4.svg";
export { ForwardRef as ReactComponent };